/**
 * Custom STL/DCM drag-and-drop uploader for Shopify product pages.
 * Modified to route add-to-cart through Bold Product Options
 * (addToCartHandler.submit) and FOX theme FoxThemeEvents.ON_ITEM_ADDED.
 *
 * External dependencies (defined elsewhere):
 *   - productIDsforMFU
 *   - subOptionsforMFU
 *   - STLViewerFile
 *   - jQuery / $
 *   - window.BOLD.options.app
 *   - window.FoxThemeEvents
 */

var fileList = [];
var fileSentList = [];
var chkfileExt = false;
var filesloaded = 0;
var filessent = 0;
var filenamesent = "";
var pID = "";
var rightArrowSVG =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAACTElEQVRoge2ZT2sTQRjGn3c2UKJUMGoVUkxFPHhLr3rxWty7h1481BZpg38giN9AKYhQkfYmFMQPUKje9uLV9hsUqtVticFSthg183rYJG02m3TXWXc2MA9hEmbfeef9zZNJ9g9gZGRkZKQgSnvC0urOW4BvcJOmt+8WP6rmE0kUFUuEOwCVyOL1y292bqqmSx2AAOH7TqNk8YeJ1c+3VPLpcKBVPwDQaQatqUCk7wAhUYj0HQAlCqHlK5QkhI5NnCiE7k2sDKHBAUoUQpMDyUFo+BVCohCdc6Hy+/ptSbwCiSKD0Xr5DQM9fWAw+2OZ2w26+wJjOBAzMO+xPimbsuHW5/eelJeDAB0HmHiZGMXQ1Rm0Ymj/OdHR58579xgKxER1QghLjFwqvL7wfHOhLwBA412TZQ+C8hfPLp1f3HgYChA6WcYgyMohP3buxdji5lyIA8MBIYRFI4UzS30cGA6IVhNwgIYDgqXkRn2/0gvQHpRhCMgmDndrj/eq5ZUeAEH4kmUIKSX/dOuVWnXyJY6pAyDBs1mF+PP7Fze+/6i41fIrBETBjv+twrNPfHJUlzzBZNeeTjphB3PqJcVTLn8qTrgnJNvuo+tO33zKFcUU5aJOSR5JabsPrjmDotIHsCKdAHtgst35q85JgakDHO3QvvIgYbv3rzhR0qXvwODDHscoHsiWAx4T2+5c9OIBXVdkvfKLvxeveCAbAP9cPKAfQKl4QMceACT8hTsgQVPfZiaUnhHouK3yDsAWCZr6OlNSfsBhZGRkZKSkv9nT3YsQFi8eAAAAAElFTkSuQmCC";
var fileIndex = 0;
var dropAreaEnabled = true;

var MAX_FILES = 15;
var ACCEPTED_EXTENSIONS = ["STL", "DCM"];
var HIDDEN_RADIO_OPTION_TITLES = [
  "From*",
  "Upload Options",
  "Upload Options*",
  "Upload Options & Shipping*",
];

window.onload = function () {
  var dropArea = document.getElementById("drop-area");
  var fileInput = document.getElementById("fileElem");

  function preventDefaults(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  function highlightDropArea() {
    dropArea.classList.add("highlight");
  }

  function unhighlightDropArea() {
    dropArea.classList.remove("active");
  }

  function handleDrop(event) {
    var files = event.dataTransfer.files;
    if (dropAreaEnabled) {
      handleFiles(files);
    }
  }

  function handleFileInputChange(event) {
    var files = event.target.files;
    if (dropAreaEnabled) {
      handleFiles(files);
    }
  }

  function handleFiles(fileListLike) {
    var incomingFiles = Array.from(fileListLike);

    if (incomingFiles.length > MAX_FILES || fileList.length > MAX_FILES) {
      alert("Maximum number of upload files is 15");
      return;
    }

    for (var i = 0; i < incomingFiles.length; i++) {
      if (fileList.length < MAX_FILES) {
        var extension = getFileExtension(incomingFiles[i].name);
        if (ACCEPTED_EXTENSIONS.indexOf(extension) !== -1) {
          fileList.push(incomingFiles[i]);
          fileSentList.push(false);
          console.log("files: " + fileList.length);
        }
      }
      console.log("files: " + fileList.length);
    }

    filesloaded = fileList.length;
    incomingFiles.forEach(validateFileExtension);
    document.getElementById("drop-area").setAttribute("disabled", "disabled");
    dropAreaEnabled = false;

    if (!chkfileExt) {
      return;
    }

    $("#filetable tr").remove();
    fileList.forEach(addFileRowToTable);

    window.scpoMultiFileUploadActive = true;

    document.getElementById("btnAddToCart").style.display = "inline-block";
    document.getElementById("btnGoToCart").style.display = "none";
    document.getElementsByClassName("bold_clone")[0].style.display = "none";
    document.getElementById("filetablebox").style.display = "inline-block";
    document.getElementById("fileuploadinfo").innerHTML =
      "[Files added to Cart: <span style = 'color: green'>" +
      filessent +
      "</span>&nbsp&nbsp/&nbsp&nbspTotal files loaded: <span style = 'color: blue'>" +
      filesloaded +
      "</span>]";
    document.getElementById("filetableinfo").innerHTML =
      "" + filesloaded + " drag-and-drop files are loaded below:";

    hideConflictingBoldOptions();
    bindFileTableRowClick();
  }

  function hideConflictingBoldOptions() {
    var form = document.getElementsByClassName("main-product-form")[0];
    var optionProduct = getBoldOptionProduct(form);

    if (optionProduct && optionProduct.optionSets) {
      optionProduct.optionSets.forEach(function (optionSet) {
        (optionSet.options || []).forEach(function (option) {
          if (typeof option.hide !== "function") {
            return;
          }

          var optionTitle =
            option.fields && option.fields.optionTitle
              ? String(option.fields.optionTitle).replace(/<[^>]+>/g, "")
              : "";
          var optionType =
            option.fields && option.fields.optionType
              ? option.fields.optionType
              : "";

          if (HIDDEN_RADIO_OPTION_TITLES.indexOf(optionTitle) !== -1) {
            option.hide();
          }

          if (optionType === "uploadfile") {
            option.hide();
          }
        });
      });
    }
  }

  function bindFileTableRowClick() {
    $("#filetable").on("click", "tr", function () {
      if ($(this).find("td:eq(4)").text().includes("Submitted")) {
        return;
      }

      $("#filetable").find('input[name="chkboxcell"]').prop("checked", false);
      $("#filetable tr").css("background-color", "#f2f2f2");
      $("#filetable tr td:nth-child(2)").html("");

      var row = $(this).closest("tr");
      row.find("td:eq(0) input").prop("checked", true);

      if (row.find("td:eq(0) input").is(":checked")) {
        row.css("backgroundColor", "#e6ffe6");
        row
          .find("td:eq(1)")
          .html('<img width="40" height="40" src=' + rightArrowSVG + ">");
      }
    });
  }

  function validateFileExtension(file) {
    var extension = getFileExtension(file.name);
    if (ACCEPTED_EXTENSIONS.indexOf(extension) !== -1) {
      chkfileExt = true;
    } else {
      alert(
        "Please note that only STL and DCM files are accepted in the drag and drop section."
      );
      chkfileExt = false;
    }
  }

  function addFileRowToTable(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onloadend = function () {
      var table = document.getElementById("filetable");
      var row = table.insertRow(table.rows.length);

      // Checkbox cell
      var checkboxCell = row.insertCell(0);
      checkboxCell.style.padding = "0px 5px 0px 0px";
      checkboxCell.style.width = "10%";

      var checkbox = document.createElement("input");
      checkbox.type = "checkbox";
      checkbox.name = "chkboxcell";
      if (fileIndex === 0) {
        checkbox.checked = true;
        row.style.backgroundColor = "#e6ffe6";
      } else {
        checkbox.checked = false;
      }
      checkboxCell.appendChild(checkbox);

      // Arrow indicator cell
      var arrowCell = row.insertCell(1);
      arrowCell.style.padding = "0px 5px 0px 10px";
      arrowCell.style.width = "10%";
      arrowCell.innerHTML = checkbox.checked
        ? '<img width="40" height="40" src=' + rightArrowSVG + ">"
        : "";

      // Preview / canvas cell
      var previewCell = row.insertCell(2);
      previewCell.style.padding = "0";
      previewCell.style.width = "25%";

      var canvasContainer = document.createElement("div");
      canvasContainer.id = "canvas" + fileIndex;
      canvasContainer.style.width = "100px";
      canvasContainer.style.height = "100px";
      previewCell.appendChild(canvasContainer);

      // Filename cell
      var filenameCell = row.insertCell(3);
      filenameCell.style.padding = "0px 5px 0px 0px";
      filenameCell.style.width = "35%";
      filenameCell.style.fontweight = "bold";
      filenameCell.innerHTML = file.name;

      // Status cell
      var statusCell = row.insertCell(4);
      statusCell.style.padding = "0px 5px 0px 0px";
      statusCell.style.width = "20%";
      statusCell.style.fontweight = "bold";
      statusCell.style.textAlign = "center";
      statusCell.innerHTML = "";

      var extension = getFileExtension(file.name);
      if (extension === "STL") {
        STLViewerFile(file, "canvas" + fileIndex);
      } else if (extension === "DCM") {
        canvasContainer.textContent = "DCM file";
        canvasContainer.style.display = "flex";
        canvasContainer.style.alignItems = "center";
        canvasContainer.style.justifyContent = "center";
        canvasContainer.style.textAlign = "center";
      }

      checkSavedDisabledRow("filetable");
      checkRowIsSlected("filetable");
      scrollToSelectedRow();
      $("#filetable tr td:nth-child(1)").hide();
      fileIndex++;
    };
  }

  if (dropArea) {
    ["dragenter", "dragover", "dragleave", "drop"].forEach(function (eventName) {
      dropArea.addEventListener(eventName, preventDefaults, false);
      document.body.addEventListener(eventName, preventDefaults, false);
    });

    ["dragenter", "dragover"].forEach(function (eventName) {
      dropArea.addEventListener(eventName, highlightDropArea, false);
    });

    ["dragleave", "drop"].forEach(function (eventName) {
      dropArea.addEventListener(eventName, unhighlightDropArea, false);
    });

    dropArea.addEventListener("drop", handleDrop, false);
    dropArea.addEventListener("click", function () {
      if (dropAreaEnabled) {
        fileInput.click();
      }
    });
    fileInput.addEventListener("change", handleFileInputChange, false);
  }
};

function getFileExtension(filename) {
  return filename.split(".").pop().toUpperCase();
}

function scrollToSelectedRow() {
  var tableBox = document.getElementById("filetablebox");
  var table = document.getElementById("filetable");
  var rowCount = table.rows.length;
  var submittedCount = 0;

  for (var i = 0; i < rowCount; i++) {
    if (table.rows[i].cells[4].innerHTML === "[Submitted]") {
      submittedCount++;
    } else {
      break;
    }
  }

  tableBox.scrollTop = 100 * submittedCount - 50;
}

function getCart() {
  jQuery.getJSON("/cart.js", function (cart) {
    console.log(JSON.stringify(cart));
  });
}

/**
 * Resolve the Bold option product bound to the product form.
 * @param {HTMLFormElement} form
 * @returns {object|null}
 */
function getBoldOptionProduct(form) {
  var app = window.BOLD && window.BOLD.options && window.BOLD.options.app;
  if (!app) {
    return null;
  }
  if (typeof app.getOptionProductByForm === "function") {
    return app.getOptionProductByForm(form);
  }
  return (app.optionProducts && app.optionProducts[0]) || null;
}

/**
 * Set or create a named text/hidden property on the product form.
 * @param {HTMLFormElement} form
 * @param {string} name
 * @param {string} value
 */
function setOrCreateFormProperty(form, name, value) {
  var input = form.elements[name];
  if (input) {
    input.value = value;
    return;
  }
  var el = document.createElement("input");
  el.type = "hidden";
  el.name = name;
  el.value = value;
  form.appendChild(el);
}

/**
 * Set or create a file property on the product form via DataTransfer.
 * @param {HTMLFormElement} form
 * @param {string} name
 * @param {File} file
 */
function setOrCreateFileProperty(form, name, file) {
  var input = form.querySelector('input[type="file"][name="' + name + '"]');
  if (!input) {
    input = document.createElement("input");
    input.type = "file";
    input.name = name;
    input.style.display = "none";
    form.appendChild(input);
  }
  var dataTransfer = new DataTransfer();
  dataTransfer.items.add(file);
  input.files = dataTransfer.files;
}

/**
 * Add the selected table row's STL/DCM file to the Shopify cart.
 * @param {string} tableId - DOM id of the file table (e.g. "filetable")
 * @param {string} productId - Product id used for RX field validation
 */
function findSTL(tableId, productId) {
  try {
    pID = productId;

    var table = document.getElementById(tableId);
    var rowCount = table.rows.length;

    if (!validateCheckbox(tableId, rowCount) || !validateFormfield(rowCount)) {
      return;
    }

    for (var rowIndex = 0; rowIndex < rowCount; rowIndex++) {
      var row = table.rows[rowIndex];
      var checkbox = row.cells[0].childNodes[0];

      if (checkbox != null && checkbox.checked === true) {
        filenamesent = row.cells[3].textContent;
        console.log("Row: " + rowIndex + " of " + rowCount);

        var selectedRowIndex = rowIndex;
        var addToCartButton = document.getElementById("btnAddToCart");
        addToCartButton.disabled = true;

        uploadSTLFile(selectedRowIndex)
          .then(function (response) {
            console.log("Successfully added to cart:", response);
            updateRow(tableId, selectedRowIndex);
          })
          .catch(function (error) {
            console.error("STL upload error:", error);
            alert(
              error.message || "The selected file could not be added to the cart."
            );
          })
          .finally(function () {
            addToCartButton.disabled = false;
          });

        break;
      }
    }
  } catch (error) {
    alert(error);
  }
}

/**
 * Validate required Prescription RX fields for the current product.
 * @param {number} rowCount - Number of rows in the file table
 * @returns {boolean}
 */
function validateFormfield(rowCount) {
  if (rowCount === 0) {
    return;
  }

  var formData = new FormData(
    document.getElementsByClassName("main-product-form")[0]
  );
  var requiredFields = productIDsforMFU[pID].map(function (field) {
    return field.toUpperCase().trim();
  });
  var subOptions = subOptionsforMFU;
  var isValid = false;

  for (var entry of formData.entries()) {
    var fieldName = entry[0];
    var fieldValue = entry[1];
    var propertyName = fieldName.substring(
      fieldName.lastIndexOf("[") + 1,
      fieldName.lastIndexOf("]")
    );

    // If this form property matches a sub-option selection, add dependent required fields
    subOptions.forEach(function (subOption) {
      var optionName = subOption[0].trim();
      var optionValue = subOption[1].trim();
      var dependentField = subOption[2].trim().toUpperCase();

      if (
        optionName === propertyName.trim() &&
        optionValue === fieldValue.trim()
      ) {
        requiredFields.push(dependentField);
      }
    });

    var normalizedPropertyName = propertyName.toUpperCase().trim();

    if (requiredFields.indexOf(normalizedPropertyName) !== -1) {
      if (fieldValue) {
        var index = requiredFields.indexOf(normalizedPropertyName);
        requiredFields.splice(index, 1);
        isValid = true;
      } else {
        alert("Please fill out the field " + fieldName + " in Prescription RX");
        return false;
      }
    }
  }

  if (requiredFields.length > 0) {
    alert("Please fill out the field " + requiredFields[0] + " in Prescription RX");
    return false;
  }

  return true;
}

/**
 * Ensure exactly one file row is selected.
 * @param {string} tableId
 * @returns {boolean}
 */
function validateCheckbox(tableId) {
  var checkedCount = 0;
  var table = document.getElementById(tableId);
  var rowCount = table.rows.length;

  for (var i = 0; i < rowCount; i++) {
    var row = table.rows[i];
    if (row.cells[0].childNodes[0].checked === true) {
      checkedCount++;
      row.style.backgroundColor = "#e6ffe6";
      row.cells[1].innerHTML =
        '<img width="40" height="40" src=' + rightArrowSVG + ">";
    }
  }

  if (checkedCount === 0 && rowCount !== 0) {
    alert("Please select the file to upload");
    return false;
  }

  if (checkedCount > 1) {
    alert("Please select only one file to upload");
    return false;
  }

  return true;
}

/**
 * Write the selected file onto the product form and trigger Bold Product Options ATC.
 * Resolves when FOX emits ON_ITEM_ADDED; rejects on Bold validation failure.
 * @param {number} _rowIndex - Unused (kept for call-site compatibility)
 * @returns {Promise<object>}
 */
function uploadSTLFile(_rowIndex) {
  var form = document.getElementsByClassName("main-product-form")[0];
  if (!form) {
    return Promise.reject(new Error("Product form not found."));
  }

  var file = null;
  for (var i = 0; i < fileList.length; i++) {
    if (fileList[i].name === filenamesent) {
      file = fileList[i];
      break;
    }
  }
  if (!file) {
    return Promise.reject(new Error("Selected file not found."));
  }

  setOrCreateFormProperty(form, "properties[Filename]", filenamesent);
  setOrCreateFileProperty(form, "properties[Upload STL file]", file);

  var optionProduct = getBoldOptionProduct(form);
  if (!optionProduct || !optionProduct.addToCartHandler) {
    return Promise.reject(new Error("Product Options is not ready."));
  }

  var foxEvents = window.FoxThemeEvents;
  if (!foxEvents || typeof foxEvents.subscribe !== "function") {
    return Promise.reject(
      new Error("FoxThemeEvents / ON_ITEM_ADDED is not available.")
    );
  }

  var expectedFilename = filenamesent;

  return new Promise(function (resolve, reject) {
    var settled = false;

    function cleanup() {
      if (typeof foxEvents.unsubscribe === "function") {
        foxEvents.unsubscribe("ON_ITEM_ADDED", onItemAdded);
      }
      if (optionProduct.ee) {
        if (typeof optionProduct.ee.off === "function") {
          optionProduct.ee.off("validation_failed", onValidationFailed);
        } else if (typeof optionProduct.ee.unsubscribe === "function") {
          optionProduct.ee.unsubscribe("validation_failed", onValidationFailed);
        }
      }
    }

    function succeed(data) {
      if (settled) {
        return;
      }
      settled = true;
      cleanup();
      resolve(data || {});
    }

    function fail(err) {
      if (settled) {
        return;
      }
      settled = true;
      cleanup();
      reject(err instanceof Error ? err : new Error(String(err)));
    }

    function onItemAdded(item) {
      var itemFilename =
        item &&
        item.properties &&
        (item.properties.Filename || item.properties["Filename"]);
      if (itemFilename && itemFilename !== expectedFilename) {
        return;
      }
      succeed(item);
    }

    function onValidationFailed(payload) {
      fail((payload && payload.error) || "Validation failed");
    }

    foxEvents.subscribe("ON_ITEM_ADDED", onItemAdded);
    if (optionProduct.ee && typeof optionProduct.ee.on === "function") {
      optionProduct.ee.on("validation_failed", onValidationFailed);
    }

    try {
      optionProduct.addToCartHandler.submit();
    } catch (error) {
      fail(error);
    }
  });
}

/**
 * Re-apply "Submitted" styling for rows already sent to the cart.
 * @param {string} tableId
 */
function checkSavedDisabledRow(tableId) {
  var table = document.getElementById(tableId);
  var rowCount = table.rows.length;

  if (rowCount <= 0) {
    return;
  }

  for (var i = 0; i < rowCount; i++) {
    if (fileSentList[i] === true) {
      var row = table.rows[i];
      var checkbox = row.cells[0].childNodes[0];

      row.style.opacity = "0.4";
      row.cells[1].innerHTML = "";
      row.cells[4].innerHTML = "[Submitted]";
      row.style.backgroundColor = "#f2f2f2";
      checkbox.checked = false;
      checkbox.disabled = true;
    }
  }
}

/**
 * Ensure one selectable row remains selected (typo in name preserved for compatibility).
 * @param {string} tableId
 */
function checkRowIsSlected(tableId) {
  var table = document.getElementById(tableId);
  var rowCount = table.rows.length;
  var checkedCount = 0;

  for (var i = 0; i < rowCount; i++) {
    var row = table.rows[i];
    if (row.cells[0].childNodes[0].checked === true) {
      checkedCount++;
      row.style.backgroundColor = "#e6ffe6";
      row.cells[1].innerHTML =
        '<img width="40" height="40" src=' + rightArrowSVG + ">";
    } else {
      row.style.backgroundColor = "#f2f2f2";
      row.cells[1].innerHTML = "";
    }
  }

  if (checkedCount === 0) {
    for (var j = 0; j < rowCount; j++) {
      var candidateRow = table.rows[j];
      var checkbox = candidateRow.cells[0].childNodes[0];

      if (checkbox.checked === false && checkbox.disabled === false) {
        checkbox.checked = true;
        candidateRow.style.backgroundColor = "#e6ffe6";
        candidateRow.cells[1].innerHTML =
          '<img width="40" height="40" src=' + rightArrowSVG + ">";
        break;
      }
    }
  }
}

function WaitRefresh() {
  setTimeout(function () {
    console.log("Executed after 2 second");
  }, 2000);
}

/**
 * Mark a row as submitted and update cart progress UI.
 * @param {string} tableId
 * @param {number} rowIndex
 */
function updateRow(tableId, rowIndex) {
  try {
    var table = document.getElementById(tableId);
    var rowCount = table.rows.length;

    if (rowIndex >= 0 && rowIndex < rowCount) {
      var row = table.rows[rowIndex];
      var checkbox = row.cells[0].childNodes[0];

      row.style.opacity = "0.4";
      row.cells[1].innerHTML = "";
      row.cells[4].innerHTML = "[Submitted]";
      row.style.backgroundColor = "#f2f2f2";
      checkbox.checked = false;
      checkbox.disabled = true;

      filessent++;
      fileSentList[rowIndex] = true;
    }

    checkRowIsSlected(tableId);
    scrollToSelectedRow();

    document.getElementById("fileuploadinfo").innerHTML =
      "[Files added to Cart: <span style='color: green'>" +
      filessent +
      "</span>&nbsp;&nbsp;/&nbsp;&nbsp;Total files loaded: <span style='color: blue'>" +
      filesloaded +
      "</span>]";
    document.getElementById("filetableinfo").innerHTML =
      filesloaded + " drag-and-drop files are loaded below:";

    if (filessent === filesloaded) {
      window.scpoMultiFileUploadActive = false;

      document.getElementById("btnAddToCart").style.display = "none";
      document.getElementById("btnGoToCart").disabled = true;
      document.getElementById("btnGoToCart").style.display = "inline-block";
      document.getElementById("btnAddMoreItems").disabled = true;
      document.getElementById("btnAddMoreItems").style.display = "inline-block";

      setTimeout(function () {
        document.getElementById("btnGoToCart").disabled = false;
        document.getElementById("btnAddMoreItems").disabled = false;
      }, 2000);
    }
  } catch (error) {
    console.error("Row update error:", error);
    alert(error.message || error);
  }
}
